<div class="custom-modal-layout">
  <div class="modal-header" style="margin-bottom: 5px !important;">
    <div class="icon">
      <img src="icons/plus-circle.svg" alt="plus Icon" />
    </div>
    <span class="title">{{ isEditMode ? 'Editar Instituição' : 'Nova Instituição' }}</span>
    <p-button icon="pi pi-times" class="close-btn" [rounded]="true" [text]="true" (onClick)="cancel()" />
  </div>

  <form [formGroup]="institutuicaoEnsinoForm" (ngSubmit)="save()">
    <div class="p-fluid grid">
      <div class="field col-12">
        <div class="file-upload">
          <p-fileupload name="myfile[]" (onSelect)="onSelectedFiles($event)" [multiple]="false"
            accept="image/png, image/jpeg, image/jpg" maxFileSize="2000000000" invalidFileTypeMessageSummary="danger"
            invalidFileTypeMessageDetail="O Ficheiro seleccionado é inválido" invalidFileLimitMessageSummary="danger"
            invalidFileLimitMessageDetail="Ficheiro muito grande. Min: 2MB">
            <ng-template #header></ng-template>
            <ng-template #content let-chooseCallback="chooseCallback">
              <a class="circular-upload preview"
                [ngStyle]="{ 'background-image': imagePreview ? 'url(' + imagePreview + ')' : 'none' }">
                <span *ngIf="!imagePreview">Foto</span>
                <div class="icon" (click)="choose($event, chooseCallback)">
                  <img src="icons/camera-01.svg" alt="">
                </div>
              </a>
            </ng-template>
            <ng-template #file></ng-template>
            <ng-template #empty></ng-template>
          </p-fileupload>
        </div>
      </div>

      <div class="field col-6">
        <label for="tipoInstituicaoEnsinoID">Tipo de Instituição</label>
        <p-select [filter]="true" appendTo="body" id="tipoInstituicaoEnsinoID" class="w-full" optionLabel="designacao"
          optionValue="id" [options]="typeofEducationalInstitution" placeholder="Seleccione o tipo"
          formControlName="TipoInstituicao" />
        <div
          *ngIf="institutuicaoEnsinoForm.get('TipoInstituicao')?.touched && institutuicaoEnsinoForm.get('TipoInstituicao')?.invalid">
          <small class="error-message" *ngIf="institutuicaoEnsinoForm.get('TipoInstituicao')?.errors?.['required']">
            Tipo de Instituição é obrigatório.
          </small>
        </div>
      </div>

      <div class="field col-6">
        <label for="nif">Número de identificação</label>
        <div class="flex align-items-center relative">
          <input id="nif" type="text" class="w-full pr-4" pInputText formControlName="NumIdentificacao"
            placeholder="Informe o NIF" />
          <button pButton *ngIf="institutuicaoEnsinoForm && isInternalInstitution"
            [disabled]="institutuicaoEnsinoForm.get('NumIdentificacao')?.invalid" type="button" icon="pi pi-search"
            class="search-btn" (click)="searchNif()" aria-label="Search"></button>
        </div>
        <div
          *ngIf="institutuicaoEnsinoForm.get('NumIdentificacao')?.touched && institutuicaoEnsinoForm.get('NumIdentificacao')?.invalid">
          <small class="error-message"
            *ngIf="institutuicaoEnsinoForm.get('NumIdentificacao')?.errors?.['required']">Número de Identificação é
            obrigatório.</small>
          <small class="error-message"
            *ngIf="institutuicaoEnsinoForm.get('NumIdentificacao')?.errors?.['minlength']">Número de Identificação deve
            ter no mínimo {{institutuicaoEnsinoForm.get('numIdentificacao')?.errors?.['minlength'].requiredLength}}
            caracteres.</small>
        </div>
      </div>

      <div class="field col-12">
        <label for="name">Nome da Instituição</label>
        <input id="name" type="text" class="w-full" pInputText autocomplete="organization" formControlName="Nome"
          placeholder="Nome da Instituição" />
        <div *ngIf="institutuicaoEnsinoForm.get('Nome')?.touched && institutuicaoEnsinoForm.get('Nome')?.invalid">
          <small class="error-message" *ngIf="institutuicaoEnsinoForm.get('Nome')?.errors?.['required']">
            Nome da Instituição é obrigatório.
          </small>
        </div>
      </div>

      <div class="field col-6">
        <label for="email">E-mail da Instituição</label>
        <input id="email" type="email" class="w-full" pInputText autocomplete="email" formControlName="Email"
          placeholder="E-mail" />
        <div *ngIf="institutuicaoEnsinoForm.get('Email')?.touched && institutuicaoEnsinoForm.get('Email')?.invalid">
          <small class="error-message" *ngIf="institutuicaoEnsinoForm.get('Email')?.errors?.['required']">
            E-mail da Instituição é obrigatório.
          </small>
        </div>
      </div>

      <div class="field col-6">
        <label for="telefone">Telefone da Instituição</label>
        <input id="telefone" type="text" class="w-full" pInputText autocomplete="tel" formControlName="Telefone"
          placeholder="Telefone da instituição" />
        <div
          *ngIf="institutuicaoEnsinoForm.get('Telefone')?.touched && institutuicaoEnsinoForm.get('Telefone')?.invalid">
          <small class="error-message" *ngIf="institutuicaoEnsinoForm.get('Telefone')?.errors?.['required']">
            Telefone da Instituição é obrigatório.
          </small>
        </div>
      </div>

      <div class="field col-6">
        <label for="country">País da Instituição</label>
        <p-select [showClear]="true" [filter]="true" appendTo="body" id="paisID" class="w-full" optionLabel="designacao"
          optionValue="id" [options]="countries" placeholder="Seleccione o país" formControlName="paisID" />
        <div *ngIf="institutuicaoEnsinoForm.get('paisID')?.touched && institutuicaoEnsinoForm.get('paisID')?.invalid">
          <small class="error-message" *ngIf="institutuicaoEnsinoForm.get('paisID')?.errors?.['required']">
            País da Instituição é obrigatório.
          </small>
        </div>
      </div>

      <div class="field col-6">
        <label for="province">Província ou Estado da Instituição</label>
        <p-select [showClear]="true" [filter]="true" appendTo="body" id="provinciaID" class="w-full"
          optionLabel="designacao" optionValue="id" [options]="provinces" placeholder="Seleccione a província"
          formControlName="ProvinciaID" />
        <div
          *ngIf="institutuicaoEnsinoForm.get('ProvinciaID')?.touched && institutuicaoEnsinoForm.get('ProvinciaID')?.invalid">
          <small class="error-message" *ngIf="institutuicaoEnsinoForm.get('ProvinciaID')?.errors?.['required']">
            Província ou Estado da Instituição é obrigatório.
          </small>
        </div>
      </div>

      <div class="field col-6">
        <label for="municipioID">Município da Instituição</label>
        <p-select [showClear]="true" [filter]="true" appendTo="body" id="municipioID" class="w-full"
          optionLabel="designacao" optionValue="id" [options]="municipalities" placeholder="Seleccione o município"
          formControlName="MunicipioID" />
        <div
          *ngIf="institutuicaoEnsinoForm.get('MunicipioID')?.touched && institutuicaoEnsinoForm.get('MunicipioID')?.invalid">
          <small class="error-message" *ngIf="institutuicaoEnsinoForm.get('MunicipioID')?.errors?.['required']">
            Município da Instituição é obrigatório.
          </small>
        </div>
      </div>

      <div class="field col-6">
        <label for="endereco">Endereço da Instituição</label>
        <input id="endereco" type="text" class="w-full" pInputText formControlName="Endereco" placeholder="Endereço" />
        <div
          *ngIf="institutuicaoEnsinoForm.get('Endereco')?.touched && institutuicaoEnsinoForm.get('Endereco')?.invalid">
          <small class="error-message" *ngIf="institutuicaoEnsinoForm.get('Endereco')?.errors?.['required']">
            Endereço da Instituição é obrigatório.
          </small>
        </div>
      </div>

      <div class="field col-6">
        <label for="sigla">Sigla da Instituição</label>
        <input id="sigla" type="text" class="w-full" pInputText formControlName="Sigla" placeholder="Sigla" />
        <div *ngIf="institutuicaoEnsinoForm.get('Sigla')?.touched && institutuicaoEnsinoForm.get('Sigla')?.invalid">
          <small class="error-message" *ngIf="institutuicaoEnsinoForm.get('Sigla')?.errors?.['required']">
            Sigla da Instituição é obrigatório.
          </small>
          <small class="error-message" *ngIf="institutuicaoEnsinoForm.get('Sigla')?.errors?.['minlength']">
            Sigla deve ter no mínimo {{institutuicaoEnsinoForm.get('Sigla')?.errors?.['minlength']?.requiredLength}}
            caracteres.
          </small>
          <small class="error-message" *ngIf="institutuicaoEnsinoForm.get('Sigla')?.errors?.['maxlength']">
            Sigla deve ter no máximo {{institutuicaoEnsinoForm.get('Sigla')?.errors?.['maxlength']?.requiredLength}}
            caracteres.
          </small>
        </div>
      </div>

      <div class="field col-6">
        <label for="natureza">Natureza da Instituição</label>
        <p-select [filter]="false" appendTo="body" id="natureza" class="w-full" optionLabel="designacao"
          optionValue="id" [options]="naturezaOptions" placeholder="Seleccione a natureza" formControlName="Natureza" />
        <div
          *ngIf="institutuicaoEnsinoForm.get('Natureza')?.touched && institutuicaoEnsinoForm.get('Natureza')?.invalid">
          <small class="error-message" *ngIf="institutuicaoEnsinoForm.get('Natureza')?.errors?.['required']">
            Natureza da Instituição é obrigatório.
          </small>
        </div>
      </div>

      <div class="field col-12">
        <label for="desc">Descrição da Instituição</label>
        <textarea id="desc" appendTo="body" pTextarea class="w-full" formControlName="DescricaoEmpresa"
          placeholder="Adicione um texto sobre a sua empresa"></textarea>
      </div>

      <!-- <div class="field col-6">
        <label>Activar instituição de ensino?</label>
        <div class="flex flex-wrap gap-4 align-items-center">
          <div class="flex items-center">
            <p-radioButton [value]="true" formControlName="IsActive" inputId="isActive1"></p-radioButton>
            <label for="isActive1" class="ml-2">Sim</label>
          </div>
          <div class="flex items-center">
            <p-radioButton [value]="false" formControlName="IsActive" inputId="isActive2"></p-radioButton>
            <label for="isActive2" class="ml-2">Não</label>
          </div>
        </div>
      </div> -->
    </div>

    <div class="modal-footer mt-0 pt-0">
      <button pButton type="button" label="Cancelar" class="p-button-outlined" (click)="cancel()"></button>
      <button pButton type="submit" [label]=" isEditMode ? 'Actualizar' : 'Salvar' " class="p-button-primary"></button>
    </div>
  </form>
</div>
<p-toast></p-toast>